const quotationChat = {
  quotationChatNavLabel: "Angebots-Chat", // translated 
  quotationChatApprovalTitle: "Angebots-Chat", // translated 
  quotationChatAccountNotApprovedTitle: "Konto nicht genehmigt", // translated 
  quotationChatAccountNotApprovedDescription:
    "Ihr Konto ist noch nicht genehmigt. Bitte wenden Sie sich an Ihren Kundenbetreuer für weitere Informationen.", // translated 
  quotationChatViewAiChat: "KI-Chat anzeigen", // translated 

  quotationRequestChatSessions: "Chat-Sitzungen", // translated 
  quotationRequestChatNoPastSessions: "Keine früheren Sitzungen", // translated 
  quotationRequestChatNewChat: "Neuer Chat", // translated 
  quotationRequestChatCloseSidebar: "Seitenleiste schließen", // translated 
  quotationRequestChatSessionFallback: "Chat-Sitzung", // translated 
  quotationRequestChatDefaultSessionName: "Neue Chat-Sitzung", // translated 
  quotationRequestChatTitle: "Angebotsanfrage-Chat", // translated 
  quotationRequestChatResponseLanguageLabel: "Antwortsprache", // translated 
  quotationRequestChatOpenSidebar: "Seitenleiste öffnen", // translated 
  quotationRequestChatRenameSession: "Sitzung umbenennen", // translated 
  quotationRequestChatDeleteSession: "Sitzung löschen", // translated 
  quotationRequestChatToggleDarkMode: "Dunkelmodus", // translated 
  quotationRequestChatSwitchToLightMode: "Zum Hellmodus wechseln", // translated 
  quotationRequestChatSwitchToDarkMode: "Zum Dunkelmodus wechseln", // translated 
  quotationRequestChatEmptyStateHeading: "Neue Angebotsanfrage-Konversation starten", // translated 
  quotationRequestChatEmptyStateSubheading:
    "Beschreiben Sie Ihre Reisebedürfnisse und erstelle eine Angebotsanfrage für Sie.", // translated 
  quotationRequestChatMessagePlaceholderStart:
    "Geben Sie Ihre Nachricht ein, um eine Konversation zu starten... (Umschalt+Eingabe für neue Zeile)", // translated 
  quotationRequestChatMessagePlaceholder: "Geben Sie Ihre Nachricht ein... (Umschalt+Eingabe für neue Zeile)", // translated 
  quotationRequestChatUploadFile: "Datei mit", // translated 
  quotationRequestChatUploadAttachment: "Anhang hochladen", // translated 

  quotationRequestChatStopGenerating: "Generierung stoppen", // translated 
  quotationRequestChatGenerateQuotation: "Angebot erstellen", // translated 
  quotationRequestChatGenerateFinalQuotation: "Finales Angebot erstellen", // translated 
  quotationRequestChatFinalizeQuotationRequest: "Angebotsanfrage abschließen", // translated 
  quotationRequestChatHoldToRecord: "Gedrückt halten, um Sprachnachricht aufzunehmen", // translated 
  quotationRequestChatRecordingReleaseToSend: "Aufnahme läuft, loslassen zum Senden", // translated 
  quotationRequestChatRecording: "Aufnahme...", // translated 
  quotationRequestChatSelectSessionFirst: "Bitte wählen Sie zuerst eine Chat-Sitzung.", // translated 
  quotationRequestChatCancelVoiceRecording: "Sprachaufnahme abbrechen", // translated 
  quotationRequestChatListening: "Zuhören...", // translated 
  quotationRequestChatTranscribing: "Transkribieren...", // translated 

  quotationRequestChatFileUploadedSuccess: "Datei erfolgreich hochgeladen.", // translated 
  quotationRequestChatUnsupportedFileType: "Nicht unterstützter Dateityp. Bitte laden Sie eine PDF-, Word-(.docx), Excel-(.xlsx), PowerPoint-(.pptx), Text/CSV- oder Bilddatei hoch.", // translated
  quotationRequestChatFailedCreateSession: "Chat-Sitzung konnte nicht erstellt werden. Bitte versuchen Sie es erneut.", // translated 
  quotationRequestChatFailedUploadFile: "Die Datei konnte nicht hochgeladen werden. Bitte versuchen Sie es erneut.", // translated 
  quotationRequestChatAnswerPendingBeforeMessage:
    "Bitte beantworten Sie die ausstehenden Fragen, bevor Sie eine weitere Nachricht senden.", // translated 
  quotationRequestChatAnswerPendingBeforeFinalize:
    "Bitte beantworten Sie die ausstehenden Fragen, bevor Sie die Angebotsanfrage abschließen.", // translated 
  quotationRequestChatFavoriteMarked: "Chat-Sitzung als Favorit markiert", // translated 
  quotationRequestChatFavoriteUnmarked: "Chat-Sitzung aus Favoriten entfernt", // translated 
  quotationRequestChatFailedSetFavorite: "Favorit konnte nicht gesetzt werden", // translated 
  quotationRequestChatFailedUnsetFavorite: "Favorit konnte nicht entfernt werden", // translated 
  quotationRequestChatRenamedSuccess: "Chat-Sitzung erfolgreich umbenannt.", // translated 
  quotationRequestChatFailedRename: "Chat-Sitzung konnte nicht umbenannt werden. Bitte versuchen Sie es erneut.", // translated 
  quotationRequestChatDeletedSuccess: "Chat-Sitzung erfolgreich gelöscht.", // translated 
  quotationRequestChatFailedDelete: "Chat-Sitzung konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.", // translated 
  quotationRequestChatAttachmentDeletedSuccess: "Anhang erfolgreich gelöscht.", // translated 
  quotationRequestChatFailedDeleteAttachment: "Anhang konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.", // translated 
  quotationRequestChatSubmittedSuccess:
    "Angebotsanfrage erfolgreich eingereicht! Ihre Anfrage wird bearbeitet.", // translated 
  quotationRequestChatFailedSubmit: "Angebotsanfrage konnte nicht eingereicht werden", // translated 
  quotationChatPdfDownloadedSuccess: "PDF erfolgreich heruntergeladen!", // translated 
  quotationChatFailedGeneratePdf: "PDF konnte nicht erstellt werden", // translated 

  quotationRequestChatSubagentRequired:
    "Bitte wählen Sie einen Unteragenten-Benutzer, bevor Sie die Angebotsanfrage einreichen.", // translated 
  quotationRequestChatAppUserLoading:
    "Ihr CRM-App-Benutzerprofil wird noch geladen. Bitte versuchen Sie es in einem Moment erneut.", // translated 
  quotationRequestChatAppUserMismatch:
    "Ihr CRM-App-Benutzerprofil stimmt nicht mit dieser Chat-Sitzung überein.", // translated 

  quotationRequestChatRenameTitle: "Chat-Sitzung umbenennen", // translated 
  quotationRequestChatSessionName: "Sitzungsname", // translated 
  quotationRequestChatEnterSessionName: "Sitzungsname eingeben", // translated 
  quotationRequestChatSaving: "Speichern...", // translated 
  quotationRequestChatSave: "Speichern", // translated 
  quotationRequestChatDeleteTitle: "Chat-Sitzung löschen", // translated 
  quotationRequestChatDeleteConfirm: "Möchten Sie diese Chat-Sitzung wirklich löschen?", // translated 
  quotationRequestChatDeleteCannotUndo: "Diese Aktion kann nicht rückgängig gemacht werden.", // translated 
  quotationRequestChatDeleting: "Löschen...", // translated 
  quotationRequestChatDelete: "Löschen", // translated 

  quotationRequestChatAttachmentsTitle: "Anhänge zum Angebotsanfrage-Chat", // translated 
  quotationRequestChatLoadingAttachments: "Anhänge werden geladen...", // translated 
  quotationRequestChatNoAttachments: "Keine Anhänge gefunden", // translated 
  quotationRequestChatDeleteAttachment: "Anhang löschen", // translated 
  quotationRequestChatUploadingAttachment: "Anhang wird hochgeladen...", // translated 
  quotationRequestChatUploadingAttachmentWait: "Bitte warten Sie, während Ihre Datei hochgeladen wird.", // translated 

  quotationRequestChatAnswerPendingQuestions: "Ausstehende Fragen beantworten", // translated 
  quotationRequestChatProposeOwnAnswer: "Eigene Antwort vorschlagen", // translated 
  quotationRequestChatTypeOwnAnswerPlaceholder: "Geben Sie Ihre eigene Antwort ein...", // translated 
  quotationRequestChatAnsweredOfTotal: "{{answered}} von {{total}} antwortete", // translated 
  quotationRequestChatReadyToSubmit: "Bereit zum Einreichen", // translated 
  quotationRequestChatSubmitAll: "Alle abschließen", // translated 
  quotationRequestChatRespondToOneQuestion: "Auf {{count}} Frage antworten", // translated 
  quotationRequestChatRespondToManyQuestions: "Auf {{count}} Fragen antworten", // translated 

  quotationRequestChatFinalizeTitle: "Angebotsanfrage abschließen", // translated 
  quotationRequestChatLoadingSessionData: "Sitzungsdaten werden geladen...", // translated 
  quotationRequestChatErrorLoadingSession: "Fehler beim Laden der Sitzungsdaten. Bitte versuchen Sie es erneut.", // translated 
  quotationRequestChatQuotationTitle: "Angebotstitel", // translated 
  quotationRequestChatExtraComments: "Zusätzliche Kommentare", // translated 
  quotationRequestChatSubmitting: "Wird eingereicht...", // translated 
  quotationRequestChatSubmit: "Einreichen", // translated 
  quotationRequestChatSubmittingOverlayTitle: "Angebotsanfrage wird eingereicht...", // translated 
  quotationRequestChatSubmittingOverlayDescription:
    "Bitte warten Sie, während Ihre Angebotsanfrage eingereicht wird.", // translated 

  quotationRequestChatSelectSubagent: "Unteragent auswählen", // translated 
  quotationRequestChatSearchSubagents: "Unteragenten suchen...", // translated 
  quotationRequestChatLoadingSubagents: "Unteragenten werden geladen...", // translated 
  quotationRequestChatNoSubagentsFound: "Keine Unteragenten gefunden", // translated 
  quotationRequestChatNoSubagentsAvailable: "Keine Unteragenten verfügbar", // translated 
  quotationRequestChatSelectedSubagent: "Ausgewählt: {{label}}", // translated 

  quotationRequestChatSubagentUsers: "Unteragenten-Benutzer", // translated 
  quotationRequestChatSearchUsers: "Benutzer suchen...", // translated 
  quotationRequestChatNoUsersFound: "Keine Benutzer gefunden", // translated 
  quotationRequestChatNoUsersAvailable: "Kein Benutzer verfügbar", // translated 

  quotationChatDownloadSummaryTitle: "Angebotszusammenfassung herunterladen", // translated 
  quotationChatDownloadSummaryDescription:
    "Füllen Sie unten Ihre Angaben aus, um eine personalisierte PDF-Zusammenfassung Ihres Reiseangebots zu erstellen. Das PDF enthält alle Reisedetails, Ziele, Transportinformationen und den Tagesplan.", // translated 
  quotationChatCustomerTitle: "Andrede", // translated 
  quotationChatSelectTitle: "Anrede", // translated 
  quotationChatHonorificMr: "Herr", // translated 
  quotationChatHonorificMrs: "Frau", // translated 
  quotationChatHonorificMs: "Frau", // translated 
  quotationChatHonorificDr: "Dr.", // translated 
  quotationChatHonorificProf: "Prof.", // translated 
  quotationChatCustomerPhone: "Telefon", // translated 
  quotationChatCustomerCompany: "Unternehmen", // translated 
  quotationChatCustomerMessage: "Nachricht", // translated 
  quotationChatCustomerCountry: "Land", // translated 
  quotationChatGenerating: "Wird erstellt...", // translated 
  quotationChatDownloadPdf: "PDF herunterladen", // translated 

  quotationChatTripSummary: "Reisezusammenfassung", // translated 
  quotationChatDownloadAsPdf: "Als PDF herunterladen", // translated 
  quotationChatNoTripSummary: "Für diese Sitzung ist keine Reisezusammenfassung verfügbar.", // translated 

  quotationRequestChatThinking: "Denke nach...", // translated 
  quotationRequestChatSources: "Quellen", // translated 
  quotationRequestChatSearchingWebFor: "Suche im Web nach: „{{query}}“...", // translated 
  quotationRequestChatServicesByTourOperator: "Vom Reiseveranstalter ausgeführte Leistungen", // translated 
  quotationRequestChatServicesByCustomer: "Vom Kunden übernommene Leistungen", // translated 
  quotationRequestChatReadyNotice:
    "Sie können jetzt ein Angebot für diese Anfrage erstellen, indem Sie auf die Schaltfläche rechts klicken.", // translated 
  quotationRequestChatGenerateFinalQuotationAria: "Finales Angebot erstellen", // translated 

  quotationRequestChatMaybeYouWantToAsk: "Vielleicht möchten Sie fragen:", // translated 
  quotationRequestChatClickToSendSuggestion: "Klicken Sie, um diese Nachricht zu senden", // translated 

  quotationRequestChatAddToFavorites: "Zu Favoriten hinzufügen", // translated 
  quotationRequestChatRemoveFromFavorites: "Aus Favoriten entfernen", // translated 
  quotationRequestChatSubmitted: "Eingereicht", // translated 

  quotationRequestChatQuotationRequest: "Angebotsanfrage: {{reference}}", // translated 
  quotationRequestChatQuotationTooltipTitle: "{{Titel}}", // translated 
  quotationRequestChatQuotationTooltipStatus: "- Status: {{status}}", // translated 

  quotationChatLoading: "Beladen...", // translated 
  quotationChatSessionNotFound: "Chat-Sitzung für dieses Angebot nicht gefunden", // translated 
  quotationChatMemberSessionNotFound: "Mitgliedssitzung für Ihr Konto nicht gefunden", // translated 
  quotationChatUnableToConnect: "Verbindung zum Chat nicht möglich", // translated 
  quotationChatConnecting: "Verbinden...", // translated 
  quotationChatTypeYourMessage: "Geben Sie Ihrer Nachricht ein...", // translated 
  quotationChatConnected: "Verbunden", // translated 
  quotationChatConnectingStatus: "Verbinden...", // translated 
  quotationChatDisconnected: "Getrennt", // translated 
};


export default quotationChat;
